import gql from 'graphql-tag';

export const OFFICES_QUERY = gql`
  query Offices($input: OfficesInput) {
    getOffices(input: $input) {
      total
      list {
        id
        name
        urltag
      }
    }
  }
`;

export const OFFICE_QUERY = gql`
  query Office($input: OfficeInput) {
    getOffice(input: $input) {
      name
      brokers {
        list {
          name
          title
          email
          cellphone
          path
        }
      }
    }
  }
`;
